import React, { useState } from "react";
import { Modal, Input, message, Alert, Button, Tag } from "antd";
import { ExperimentOutlined } from "@ant-design/icons";
import customClientAxios from "../customAxios";
import { AdminNurtureTemplateTestSend } from "../utils/ApiEndpoints";

const PHONE_RX = /^\+\d{8,15}$/;

export default function TestSendDialog({ row, sequenceKey, onClose }) {
  const [phone, setPhone] = useState("+91");
  const [sending, setSending] = useState(false);

  const tpl = row?.template;
  const seq = sequenceKey || row?.sequenceKey || "prospect";

  const handleSend = async () => {
    if (!PHONE_RX.test(phone)) {
      message.error("Phone must be E.164 — e.g. +919876543210");
      return;
    }
    setSending(true);
    try {
      const { data } = await customClientAxios().post(
        AdminNurtureTemplateTestSend(row.stepDay, seq),
        { phoneE164: phone }
      );
      message.success(data?.data?.message || "Test-send accepted");
      onClose();
    } catch (e) {
      message.error(e?.response?.data?.error?.message || "Test-send failed");
    } finally {
      setSending(false);
    }
  };

  return (
    <Modal
      title={
        <div>
          <ExperimentOutlined style={{ marginRight: 8 }} />
          Test send — {seq} D{row?.stepDay} <Tag style={{ marginLeft: 8 }}>{tpl?.name}</Tag>
        </div>
      }
      open={!!row}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>Cancel</Button>,
        <Button key="send" type="primary" loading={sending} onClick={handleSend} icon={<ExperimentOutlined />}>
          Send test
        </Button>,
      ]}
    >
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 12 }}
        message="Sends one WhatsApp message to the phone you specify, using this template. Marked as a test so it won't pollute the analytics."
      />
      <div style={{ fontSize: 13, color: "#64748b", marginBottom: 6 }}>Recipient (E.164, with country code)</div>
      <Input
        size="large"
        placeholder="+919876543210"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
      />
    </Modal>
  );
}
